import React from 'react';

const VaultoLogo = ({ className = "h-8 w-auto", showText = true }) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <img 
        src="/vaulto4.png" 
        alt="Vaulto" 
        className={showText ? "h-full w-auto object-contain" : "h-full w-auto object-contain object-top"}
        style={!showText ? { 
          clipPath: 'inset(0 0 20% 0)',
          marginBottom: '-20%'
        } : undefined}
      />
    </div>
  );
};

export default VaultoLogo;
